import React, { useState }  from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { InfoTable, InfoTableAddRow } from '@myplay/ui';

import "./AthletesTable.scss";
import AthletesTableItem from './AthletesTableItem';
import I18N from "../../I18N";

const mockTableHeaders = ["", "Jersey", "Position", "Age", "Wight", "Hight", "A.Ppg", ""];

const AthletesTable = ({ athletes, onAddPlayer, onDeletePlayer, currentTeamId }) => {
  const [ selectedPlayer, setSelectedPlayer ] = useState(null);
  const handleDelete = (event, athlete) => {
    event.stopPropagation();
    onDeletePlayer(athlete)
  };

  const handleSelectPlayer = ({ athlete }) => {
    if(selectedPlayer && athlete._id === selectedPlayer._id) {
      setSelectedPlayer(null);
      return;
    }
    setSelectedPlayer(athlete);
  }

  return (
    <div className="athletes-table" data-testid="athletes-table">
      <InfoTable
        headers={mockTableHeaders}
        gridTemplateColumns="20% 6% 13% 6% 8% 6% 6% auto"
        onChildClick={handleSelectPlayer}
      >
        {athletes.map(athlete => 
          <AthletesTableItem 
            athlete={athlete} 
            onDelete={event=> handleDelete(event, athlete)} 
            isSelected={selectedPlayer && athlete._id === selectedPlayer._id}
            currentTeamId={currentTeamId}
          />)
        }
      </InfoTable>
      <InfoTableAddRow
        text={I18N.t("ADD_NEW_PLAYER").toUpperCase()}
        onClick={onAddPlayer}
      />
    </div>
  );
};

AthletesTable.propTypes = {
  athletes: PropTypes.array, 
  currentTeamId: PropTypes.string, 
  onAddPlayer: PropTypes.func, 
  onDeletePlayer: PropTypes.func
};

AthletesTable.defaultProps = {
  athletes: [], 
  currentTeamId: "", 
  onAddPlayer: ()=> {}, 
  onDeletePlayer: ()=> {}
}

export default inject("TeamsStore")(AthletesTable);